module.exports = __webpack_public_path__ + "img/banner-background.22e3a19.png";